import { ReactNode } from 'react'
import { useStore } from 'react-redux'

import { PersistGate } from 'redux-persist/integration/react'

export default function ReduxPersistor({
  children,
  loading,
}: {
  children: React.ReactElement | React.ReactElement[]
  // Rendered — and prerendered — until the persisted slices are restored. Defaults to nothing.
  loading?: ReactNode
}): React.ReactElement {
  const store = useStore()
  return (
    <PersistGate loading={loading ?? null} persistor={store.__persistor}>
      {children}
    </PersistGate>
  )
}
